<style>

</style>
<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'TicketModal',
    props:[
        "data",
        "modelOpen",
    ],
    data() {
        return {
            submitted: false,
            description:'',
            dataList:[],
            controlList:[
                "Kablo kontrolü yapıldımı?",
                "Poe ve Adaptör kontrolü yapıldımı?",
            ],
            selected:[],
            secenekler:'',
            groupList: [],
        };
    },
    computed:{
        title(){
            return `<strong style='font-size:15px'># ${ this.dataList  ?   this.dataList.ticket_num : 'Yeni Ticket' }</strong>`;
        }
    },
    watch:{
        modelOpen(){
            this.description= ''
            this.dataList= []
            this.selected= []
            this.secenekler= ''
            this.loadItems();

            this.getGroup()
        },
        secenekler(){
            this.description= ''
        }
    },
    methods: {
        onlyAdmin(name) {
            const userdata = JSON.parse(localStorage.getItem('userdata'))
            return userdata[name] 
        },
        send(){
            this.$http.post(`tickets/${this.data.id}/store`, {
                        description:this.description,
                        technic_group_id:this.secenekler
                    })
                    .then(response =>{ 
                        notify.success(response.data.message)
                    })
                    .finally(()=>{
                         this.loadItems()
                         this.description = ''
                        })
        },
        loadItems(){
            this.$http.post(`tickets/${this.data.id}`)
                  .then(response => this.dataList = response.data)
        },
        close(){
            this.$parent.$bvModal.hide('ticket_modal')
        },
        created_at(obj){
            return this.formatDate(obj, "DD.MM.YYYY HH:mm")
        },
        getGroup(){
            this.$http.post('/technic-service/group')
                .then(response => this.groupList= response.data)
        },
        ariza(){
            this.$http.post('/technic-service/store', {
                subs_id: this.data.id, 
                type: 3, 
                referans: "search", 
                group: this.dataList.technic_group_id, 
                content: this.dataList.content
            })
            .then(resp => {
         
              if(resp.data.code == 100){
                notify.success(resp.data.message)
                this.close()
              }else{
                notify.error(resp.data.message)
              }
            })
        }
    },
};
</script>

<template>
<b-modal id="ticket_modal"  size="xl" no-close-on-backdrop hide-footer>
     <template #modal-title>
        <span v-html="title"></span>
    </template>
    <form>
        
        <div v-if="!dataList">
            <div class="d-flex flex-wrap mb-1" v-for="(data,i) in controlList" :key="i"> 
                <div class="col col-form-label form-control">
                    <div class="d-flex align-items-center me-2">
                    <input type="checkbox" :id="'control'+i" class="me-2" v-model="selected" :value="i"/>
                    <label :for="'control'+i" class="mb-0">{{ data }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-wrap mb-1" v-if="dataList" > 
            <div class="col col-form-label form-control border border-primary">
                <div class="d-flex justify-content-between flex-wrap mb-1"> 
                    <div class="yazan me-2"><span class="me-1 badge bg-primary rounded-pill">{{ dataList.name }}</span></div>
                    <div class="tarih">{{ created_at(dataList.created_at) }}</div>
                </div>
                <div class="icerik me-2">
                    <strong>{{ dataList.group_name }} </strong><br>
                    {{ dataList.content }}</div>
            </div>
        </div>
        
         <div class="d-flex flex-wrap mb-1" v-for="(data,i) in dataList.transactions" :key="i"> 
            <div class="col col-form-label form-control border border-warning">
                <div class="d-flex justify-content-between flex-wrap mb-1"> 
                    <div class="yazan me-2"><span class="me-1 badge bg-warning rounded-pill">{{ data.name }}</span></div>
                    <div class="tarih">{{ created_at(data.created_at) }}</div>
                </div>
                <div class="icerik me-2">{{ data.content }}</div>
            </div>
        </div>
 
        <div class="d-flex justify-content-between mt-3" v-if="!dataList && selected.length == 2">
           <div class="col-md-12">
                <v-select 
                    v-model="secenekler"
                    :options="groupList"
                    :reduce="form => form.id"
                    placeholder="Seçiniz"
                    label="name">
                <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3"  v-if="dataList ||selected.length == 2" >
           <textarea v-model="description" class="form-control" placeholder="Bir şeyler yazın"></textarea>
        </div>
        <div class="d-flex justify-content-between mt-3" v-if="dataList || selected.length == 2">
           <button type="button" v-if="onlyAdmin('role_name') == 'admin' && dataList" class="btn btn-outline-primary me-2" @click="ariza()">Arıza Listesine At</button>
           <button type="button" class="btn btn-primary" @click="send()">
                <template v-if="dataList">Yanıtla</template>
                <template v-else>Kaydet</template>
            </button>
        </div>
    </form>
</b-modal>
</template>